import React, { useEffect, useState, useRef } from "react";
import { Form, FormGroup, Label, Input, Container } from "reactstrap";
import "cropperjs/dist/cropper.css";
import { Card } from "reactstrap";
import SearchField from "../../components/SearchField";
import PackageSelector from "../../components/PackageSelector";
import Cropper from "cropperjs";
import api, { baseURL } from "../../Axios";
import Usercard from "../../components/MailboxUser";

import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import icon from "../../assets/img/placeholder.png";
import Swal from "sweetalert2";

const ChatBoxApprovel = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [render, setRender] = useState(false);
  const [search, setSearch] = useState("");

  // User Activity - profiles from API
  const [activityProfiles, setActivityProfiles] = useState([]);
  const [activityLoading, setActivityLoading] = useState(false);

  const [user, setUser] = useState([]);

  const [getUser, setGetUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [intrestsearch, setIntrestSearch] = useState("");

  const [intrestuser, setIntrestUser] = useState([]);

  const [getIntrestUser, setGetIntrestUser] = useState([]);
  const [selectedIntrestUser, setSelectedIntrestUser] = useState(null);

  const [search2, setSearch2] = useState("");
  const [getUser2, setGetUser2] = useState([]);
  const [interest, setInterest] = useState([]);
  const [horoscope, setHoroscope] = useState([]);
  const [selectedUser2, setSelectedUser2] = useState(null);
  const [search3, setSearch3] = useState("");
  const [getUser3, setGetUser3] = useState([]);
  const [meet, setMeet] = useState([]);
  const [getUser4, setGetUser4] = useState([]);
  const [selectedUser4, setSelectedUser4] = useState(null);

  const [search4, setSearch4] = useState("");
  const [selectedUser3, setSelectedUser3] = useState(null);

  const [result, setResult] = useState([]);
  const [getUser5, setGetUser5] = useState([]);
  const [selectedUser5, setSelectedUser5] = useState(null);

  const [search5, setSearch5] = useState("");
  const [marriage, setMarriage] = useState([]);
  const [getUser6, setGetUser6] = useState([]);
  const [selectedUser6, setSelectedUser6] = useState(null);

  const [search6, setSearch6] = useState("");
  const [reject, setReject] = useState([]);
  const [getUser7, setGetUser7] = useState([]);
  const [selectedUser7, setSelectedUser7] = useState(null);

  const [search7, setSearch7] = useState("");
  const [locked, setLocked] = useState([]);
  const [getUser8, setGetUser8] = useState([]);
  const [selectedUser8, setSelectedUser8] = useState(null);

  const [search8, setSearch8] = useState("");
  const [getmarried, setGetmarried] = useState([]);
  const [getUser9, setGetUser9] = useState([]);
  const [selectedUser9, setSelectedUser9] = useState(null);

  const [search9, setSearch9] = useState("");
  const [showLocked, setShowLocked] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");

  const handleSelectChange = (e) => {
    setSelectedUserId(e.target.value);
  };
  const selected =
    user.find(
      (u) => String(u.id || u.userId || u._id) === String(selectedUserId)
    ) || null;

  // find selected user details

  const [InterestId, setInterestId] = useState("");

  const handleInterestChange = (e) => {
    setInterestId(e.target.value);
  };
  const selectedInterest =
    interest.find(
      (u) => String(u.id || u.userId || u._id) === String(InterestId)
    ) || null;

  const [horoscopeId, setHoroscopeId] = useState("");

  const handleHoroscopeChange = (e) => {
    setHoroscopeId(e.target.value);
  };
  const selectedHoroscope =
    horoscope.find(
      (u) => String(u.id || u.userId || u._id) === String(horoscopeId)
    ) || null;

  const [waitMeetId, setWaitMeetId] = useState("");

  const handleWaitMeetChange = (e) => {
    setWaitMeetId(e.target.value);
  };
  const selectedWaitMeet =
    meet.find(
      (u) => String(u.id || u.userId || u._id) === String(waitMeetId)
    ) || null;

  const [waitResultId, setWaitResultId] = useState("");

  const handleWaitResultChange = (e) => {
    setWaitResultId(e.target.value);
  };
  const selectedWaitResult =
    result.find(
      (u) => String(u.id || u.userId || u._id) === String(waitResultId)
    ) || null;

  const [marriageId, setMarriageId] = useState("");

  const handleMarriageChange = (e) => {
    setMarriageId(e.target.value);
  };
  const selectedMarriage =
    marriage.find(
      (u) => String(u.id || u.userId || u._id) === String(marriageId)
    ) || null;
  const [getMarriedId, setGetMarriedId] = useState("");

  const handleGetMarriedChange = (e) => {
    setGetMarriedId(e.target.value);
  };
  const selectedGetMarried =
    getmarried.find(
      (u) => String(u.id || u.userId || u._id) === String(getMarriedId)
    ) || null;

  const [rejectId, setRejectId] = useState("");

  const handleRejectChange = (e) => {
    setRejectId(e.target.value);
  };
  const selectedReject =
    reject.find(
      (u) => String(u.id || u.userId || u._id) === String(rejectId)
    ) || null;
  // find selected user details

  const searchMember = (inputValue, setResults) => {
    if (!inputValue.trim()) return;

    api
      .post(`/admin/userProfile/search?input=${inputValue}`)
      .then((v) => {
        let data = v.data.data;
        if (Array.isArray(data)) {
          setResults(data);
        } else if (data) {
          setResults([data]);
        } else {
          setResults([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setResults([]);
      });
  };
  const [selectedPackage, setSelectedPackage] = useState(null);

  const handlePackageSelect = (value, inputValue) => {
    setSelectedPackage(value);
    if (inputValue < 0) return;
    const userId = (selectedUser && selectedUser.id) || 0;

    api
      .get(
        `/admin/profilesActivity/mailbox?userId=${userId}&input=${inputValue}`
      )
      .then((res) => {
        const data = res.data.data;
        setUser(Array.isArray(data) ? data : []);
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setUser([]);
      });
  };
  const handleInterset = () => {
    const userId = (selectedUser2 && selectedUser2.id) || 0;

    api
      .get(`/admin/profilesActivity/interestLockedProfiles?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setInterest(Array.isArray(data) ? data : []); // ✅ force into array
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setInterest([]); // fallback to empty array if error
      });
  };
  const handleHoroscope = () => {
    setShowLocked(true);
    const userId = (selectedUser3 && selectedUser3.id) || 0;

    api
      .get(`/admin/profilesActivity/horoscopeLockedProfiles?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setHoroscope(Array.isArray(data) ? data : []); // ✅ force into array
      })
      .catch((err) => {
        console.error("API Error:", err);
        setHoroscope([]); // fallback to empty array if error
      });
  };
  const handleMeet = () => {
    const userId = (selectedUser4 && selectedUser4.id) || 0;

    api
      .get(`/admin/profilesActivity/waitingToMeet?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setMeet(Array.isArray(data) ? data : []); // ✅ force into array
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setMeet([]); // fallback to empty array if error
      });
  };
  const handleResult = () => {
    const userId = (selectedUser5 && selectedUser5.id) || 0;

    api
      .get(`admin/profilesActivity/waitingForResult?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setResult(Array.isArray(data) ? data : []);
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setResult([]);
      });
  };
  const handleMarriage = () => {
    const userId = (selectedUser6 && selectedUser6.id) || 0;

    api
      .get(`/admin/profilesActivity/marriageProcessing?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setMarriage(Array.isArray(data) ? data : []);
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setMarriage([]);
      });
  };
  const handleReject = () => {
    const userId = (selectedUser7 && selectedUser7.id) || 0;

    api
      .get(`/admin/profilesActivity/marriageRejectedProfiles?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setReject(Array.isArray(data) ? data : []);
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setReject([]);
      });
  };
  const handleLockedProfile = () => {
    const userId = (selectedUser8 && selectedUser8.id) || 0;

    api
      .get(`(/admin/profilesActivity/waitingToMeet?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setLocked(Array.isArray(data) ? data : []);
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLocked([]);
      });
  };
  const handleGetMarried = () => {
    const userId = (selectedUser9 && selectedUser9.id) || 0;
    console.log(selectedUser9);

    api
      .get(`/admin/profilesActivity/getMarriedProfiles?userId=${userId}`)
      .then((res) => {
        const data = res.data.data;
        setGetmarried(Array.isArray(data) ? data : []);
        setShowLocked(true);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setGetmarried([]);
      });
  };
  const handleSelect = (user) => {
    setSelectedUser(user);
    setSearch(user.userName || "");
    setGetUser([]);
  };
  const handleReInterestSend = async (u) => {
    try {
      let payload = {};

      if (
        selectedPackage === "To Reject" ||
        selectedPackage === "To Reject Horoscope" ||
        selectedPackage === "Two side Reject Horoscope" ||
        selectedPackage === "Rejected Profiles"
      ) {
        payload = {
          userId: selectedUser && selectedUser.id,
          interestId: u.id,
        };
      } else if (
        selectedPackage === "From Reject" ||
        selectedPackage === "From Reject Horoscope"
      ) {
        payload = {
          userId: u.id,
          interestId: selectedUser && selectedUser.id,
        };
      }

      const res = await api.post(
        "admin/profilesActivity/sendInterest",
        payload
      );

      console.log(res.data.data);
      if (res.data.status === 200) {
        Swal.fire({
          title: "Success",
          text: res.data.data,
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to send interest",
          icon: "error",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: "Error",
        text: "Failed to send interest",
        icon: "error",
      });
    }
  };
  const handleMatch = async (userId, partnerId, status) => {
    try {
      const payload = {
        userId,
        partnerId,
        status,
      };

      const res = await api.post(
        "admin/profilesActivity/horoscopeMatchUpdate",
        payload
      );

      Swal.fire({
        title: "Success",
        text: res.data.data,
        icon: "success",
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };

  const handleLock = async (userId, partnerId) => {
    try {
      const payload = {
        userId,
        partnerId,
      };

      const res = await api.post(
        "admin/profilesActivity/adminLockTheProfile",
        payload
      );

      Swal.fire({
        title: "Success",
        text: res.data.data,
        icon: "success",
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };
  const handleInterest = async (userId, interestId, status) => {
    const payload = {
      userId, // make sure this is not null
      interestId, // from u.id
      status, // "accept" or "decline"
    };

    const response = await api.post(
      "admin/profilesActivity/interestUpdate",
      payload
    );

    Swal.fire({
      title: "Success",
      text: "Interest Status successfully",
      icon: "success",
    });
  };
  const handleMarraige = async (userId, partnerId, status) => {
    const payload = {
      userId, // make sure this is not null
      partnerId, // from u.id
      status, // "accept" or "decline"
    };

    const response = await api.post(
      "/admin/profilesActivity/finalResult",
      payload
    );

    Swal.fire({
      title: "Success",
      text: "Marriage Status updated successfully",
      icon: "success",
    });
  };
  const handleMarraigeProcessing = async (userId, partnerId, status) => {
    const payload = {
      userId, // make sure this is not null
      partnerId, // from u.id
      status, // "accept" or "decline"
    };

    const response = await api.post(
      "/admin/profilesActivity/marriageProposal",
      payload
    );

    Swal.fire({
      title: "Success",
      text: "Marriage Status updated successfully",
      icon: "success",
    });
  };
  const [isAccepted1, setIsAccepted1] = useState(false);
  const [isAccepted2, setIsAccepted2] = useState(false);
  const [isAccepted3, setIsAccepted3] = useState(false);
  const [isAccepted4, setIsAccepted4] = useState(false);
  const handleToggle = async (toggleType, user, partner) => {
    try {
      let payload = {};

      if (toggleType === "first") {
        payload = {
          userId: user,
          partnerId: partner,
          status: !isAccepted1 ? "accept" : "reject",
        };
        setIsAccepted1((prev) => !prev);
      } else if (toggleType === "second") {
        payload = {
          userId: partner,
          partnerId: user,
          status: !isAccepted2 ? "accept" : "reject",
        };
        setIsAccepted2((prev) => !prev);
      }

      await api.post("/admin/profilesActivity/meetStatus", payload);
      console.log("API sent:", payload);
    } catch (error) {
      console.error("API error:", error);
    }
  };
  const handleToggleReject = async (toggleType, user, partner) => {
    try {
      let payload = {};

      if (toggleType === "first") {
        payload = {
          userId: user,
          partnerId: partner,
          status: !isAccepted3 ? "accept" : "reject",
        };
        setIsAccepted3((prev) => !prev);
      } else if (toggleType === "second") {
        payload = {
          userId: partner,
          partnerId: user,
          status: !isAccepted4 ? "accept" : "reject",
        };
        setIsAccepted4((prev) => !prev);
      }

      await api.post("/admin/profilesActivity/marriageProposal", payload);
      console.log("API sent:", payload);
    } catch (error) {
      console.error("API error:", error);
    }
  };

  // Fetch profiles for User Activity tab
  useEffect(() => {
    const fetchActivityProfiles = async () => {
      setActivityLoading(true);
      try {
        const response = await api.get("/admin/profilesActivity/getProfile");
        const data = response.data;
        let profilesData = [];
        if (Array.isArray(data)) {
          profilesData = data;
        } else if (data.profiles && Array.isArray(data.profiles)) {
          profilesData = data.profiles;
        } else if (data.data && Array.isArray(data.data)) {
          profilesData = data.data;
        } else if (data.users && Array.isArray(data.users)) {
          profilesData = data.users;
        }
        setActivityProfiles(profilesData);
      } catch (err) {
        console.error("Error fetching activity profiles:", err);
        setActivityProfiles([]);
      } finally {
        setActivityLoading(false);
      }
    };
    fetchActivityProfiles();
  }, []);

  // Calculate age helper
  const calculateAgeFromDob = (dob) => {
    if (!dob) return "-";
    const parts = dob.split("-");
    if (parts.length !== 3) return "-";
    const [day, month, year] = parts;
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  return (
    <div className="col-12">
      <Row>
        <Col xs={12}>
          <section className="box">
            <div style={{ padding: "100px 0px", backgroundColor: "white" }}>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => setActiveTab("1")}
                  >
                    User Activity
                  </NavLink>
                </NavItem>{" "}
                <NavItem>
                  <NavLink
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => setActiveTab("2")}
                  >
                    Interest Lock Profile
                  </NavLink>
                </NavItem>{" "}
                <NavItem>
                  <NavLink
                    className={activeTab === "3" ? "active" : ""}
                    onClick={() => setActiveTab("3")}
                  >
                    Horoscope Lock Profile
                  </NavLink>
                </NavItem>{" "}
                <NavItem>
                  <NavLink
                    className={activeTab === "4" ? "active" : ""}
                    onClick={() => setActiveTab("4")}
                  >
                    Wait for meeting
                  </NavLink>
                </NavItem>{" "}
                <NavItem>
                  <NavLink
                    className={activeTab === "5" ? "active" : ""}
                    onClick={() => setActiveTab("5")}
                  >
                    Waiting For Result
                  </NavLink>
                </NavItem>{" "}
                <NavItem>
                  <NavLink
                    className={activeTab === "6" ? "active" : ""}
                    onClick={() => setActiveTab("6")}
                  >
                    Marriage processing Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "7" ? "active" : ""}
                    onClick={() => setActiveTab("7")}
                  >
                    Marrgiage Rejected Profiles
                  </NavLink>
                </NavItem>{" "}
                {/* <NavItem>
                  <NavLink
                    className={activeTab === "8" ? "active" : ""}
                    onClick={() => setActiveTab("8")}
                  >
                    Admin Locked profile
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink
                    className={activeTab === "9" ? "active" : ""}
                    onClick={() => setActiveTab("9")}
                  >
                    Get married Profile
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab} className="pt-4">
                {/* Other Tabs */}
                <TabPane tabId="1">
                  <Row>
                    <Col xs={12} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search}
                                  onChange={(e) => setSearch(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search, setGetUser)
                                  }
                                  results={getUser}
                                  onSelect={handleSelect}
                                />
                              </Col>

                              {/* ✅ Usercard */}
                              {/* ✅ Package Dropdown */}
                              {selectedUser && (
                                <Col>
                                  <PackageSelector
                                    onSelect={handlePackageSelect}
                                  />
                                </Col>
                              )}

                              {/* ✅ User list rendering */}
                              {selectedUser &&
                                showLocked &&
                                (selectedPackage !== "Admin Send Intrest") && (
                                  <Col>
                                    {/* Dropdown for user selection */}
                                    <Card body className="p-3">
                                      {Array.isArray(user) &&
                                        user.length > 0 ? (
                                        <select
                                          className="form-select"
                                          value={selectedUserId} // ✅ state variable
                                          onChange={handleSelectChange}
                                        >
                                          <option value="">
                                            -- Select User --
                                          </option>
                                          {user.map((u) => (
                                            <option
                                              key={u.id}
                                              value={u.id}
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {u.userName || "Unknown"} (
                                              {u.profileId || ""})
                                            </option>
                                          ))}
                                        </select>
                                      ) : (
                                        <p>No Profiles</p> // ✅ show if array empty
                                      )}
                                    </Card>
                                  </Col>
                                )}

                              {/* Show card only for selected user */}

                              {selectedPackage === "Admin Send Intrest" && (
                                <Col>
                                  <Card body className="p-3">
                                    <SearchField
                                      value={intrestsearch}
                                      onChange={(e) =>
                                        setIntrestSearch(e.target.value)
                                      }
                                      onSearch={() =>
                                        searchMember(
                                          intrestsearch,
                                          setGetIntrestUser
                                        )
                                      }
                                      results={getIntrestUser}
                                      onSelect={(user) => {
                                        setSelectedIntrestUser(user);
                                        setIntrestSearch(user.userName || "");
                                        setGetIntrestUser([]);
                                      }}
                                    />
                                  </Card>
                                </Col>
                              )}

                              {selected &&
                                (selectedPackage !== "Admin Send Intrest") ? (
                                <Col key={selected.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selected.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selected.profileId || ""}
                                      </span>
                                    </h3>
                                    {/* Buttons based on selectedPackage */}
                                    ...
                                  </div>
                                </Col>
                              ) : null}

                              {selectedIntrestUser && (
                                <Col key={selectedIntrestUser.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedIntrestUser.userName ||
                                        "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedIntrestUser.profileId || ""}
                                      </span>
                                    </h3>

                                    <div style={{ marginTop: 10 }}>
                                      <div style={{ display: "flex" }}>
                                        <button
                                          className="btn btn-success btn-sm me-2"
                                          onClick={() =>
                                            handleInterest(
                                              selectedUser.id,
                                              selectedIntrestUser.id,
                                              "accept"
                                            )
                                          }
                                        >
                                          Accept
                                        </button>

                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleInterest(
                                              selectedUser.id,
                                              selectedIntrestUser.id,
                                              "decline"
                                            )
                                          }
                                        >
                                          Reject
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              )}
                            </Row>
                          </section>
                          {selectedUser && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser */}
                                <Col md={5}>
                                  <Usercard
                                    name={
                                      (selectedUser && selectedUser.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser &&
                                        selectedUser.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser && selectedUser.dob) || ""
                                    }
                                    education={
                                      (selectedUser &&
                                        selectedUser.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser && (selectedUser.jobtype || selectedUser.jobType || selectedUser.employedIn)) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser &&
                                        selectedUser.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser && selectedUser.salary) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser && selectedUser.kulam) || ""
                                    }
                                    dhosam={
                                      (selectedUser && selectedUser.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser && selectedUser.phone) || ""
                                    }
                                    gender={
                                      (selectedUser && selectedUser.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser && selectedUser.email) || ""
                                    }
                                    taluk={
                                      (selectedUser && selectedUser.taluk) || ""
                                    }
                                    district={
                                      (selectedUser && selectedUser.district) || ""
                                    }
                                    state={
                                      (selectedUser && selectedUser.state) || ""
                                    }
                                    image={
                                      selectedUser && selectedUser.profilePic
                                        ? selectedUser &&
                                        selectedUser.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser && (
                                  <>
                                    {selected ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={selected.userName || ""}
                                          profileId={selected.profileId || ""}
                                          dob={selected.dob || ""}
                                          education={selected.education || ""}
                                          employedIn={selected.jobtype || selected.jobType || selected.employedIn || ""}
                                          occupation={selected.occupation || ""}
                                          monthlyIncome={
                                            selected.salary || selected.monthlyIncome || ""
                                          }
                                          kulam={selected.kulam || ""}
                                          dhosam={selected.dhosam || ""}
                                          phone={selected.phone || ""}
                                          gender={selected.gender || ""}
                                          email={selected.email || ""}
                                          taluk={selected.taluk || ""}
                                          district={selected.district || ""}
                                          state={selected.state || ""}
                                          image={
                                            selected.profilePic
                                              ? selected.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : selectedIntrestUser ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={selectedIntrestUser.userName || ""}
                                          profileId={selectedIntrestUser.profileId || ""}
                                          dob={selectedIntrestUser.dob || ""}
                                          education={selectedIntrestUser.education || ""}
                                          employedIn={selectedIntrestUser.jobtype || selectedIntrestUser.jobType || selectedIntrestUser.employedIn || ""}
                                          occupation={selectedIntrestUser.occupation || ""}
                                          monthlyIncome={
                                            selectedIntrestUser.salary || selectedIntrestUser.monthlyIncome || ""
                                          }
                                          kulam={selectedIntrestUser.kulam || ""}
                                          dhosam={selectedIntrestUser.dhosam || ""}
                                          phone={selectedIntrestUser.phone || ""}
                                          gender={selectedIntrestUser.gender || ""}
                                          email={selectedIntrestUser.email || ""}
                                          taluk={selectedIntrestUser.taluk || ""}
                                          district={selectedIntrestUser.district || ""}
                                          state={selectedIntrestUser.state || ""}
                                          image={
                                            selectedIntrestUser.profilePic
                                              ? selectedIntrestUser.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}

                          {/* Profile Cards from API */}
                          <div style={{ marginTop: "30px", borderTop: "1px solid #eee", paddingTop: "30px" }}>
                            <h5 style={{ fontWeight: 700, marginBottom: "20px", color: "#333" }}>
                              All Profiles ({activityProfiles.length})
                            </h5>

                            {activityLoading && (
                              <p style={{ color: "#666" }}>Loading profiles...</p>
                            )}

                            {!activityLoading && activityProfiles.length === 0 && (
                              <p style={{ color: "#666" }}>No profiles available.</p>
                            )}

                            {!activityLoading && activityProfiles.length > 0 && (
                              <Row>
                                {activityProfiles.map((profile, index) => {
                                  const age = calculateAgeFromDob(profile.dob);
                                  const locationParts = [profile.taluk, profile.district, profile.state].filter(Boolean);
                                  const locationString = locationParts.length > 0 ? locationParts.join(", ") : "-";

                                  return (
                                    <Col xs={12} md={6} lg={4} key={profile.id || index}>
                                      <div
                                        style={{
                                          width: "100%",
                                          padding: "20px",
                                          marginBottom: "24px",
                                          border: "1px solid #dcdcdc",
                                          borderRadius: "12px",
                                          background: "#fff",
                                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                                        }}
                                      >
                                        {/* Profile ID Badge */}
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: 600,
                                            color: "#4caf50",
                                            background: "#e6f4ea",
                                            padding: "2px 8px",
                                            borderRadius: "6px",
                                          }}
                                        >
                                          {profile.profileId}
                                        </span>

                                        {/* Profile Image */}
                                        <div style={{ marginTop: "12px", marginBottom: "12px" }}>
                                          <img
                                            src={profile.profilePic ? baseURL + profile.profilePic : icon}
                                            alt="Profile"
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              borderRadius: "8px",
                                              objectFit: "cover",
                                              border: "1px solid #eee",
                                              background: "#fafafa",
                                            }}
                                          />
                                        </div>

                                        {/* Name */}
                                        <h5 style={{ fontWeight: 700, fontSize: "18px", color: "#222", marginBottom: "8px" }}>
                                          {profile.userName || "-"}
                                        </h5>

                                        {/* Details */}
                                        <ul style={{ listStyle: "none", paddingLeft: 0, fontSize: "14px", color: "#555", lineHeight: "1.8" }}>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>DOB:</strong> {profile.dob || "-"} / {age} yrs</li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Gender:</strong> <span style={{ textTransform: "capitalize" }}>{profile.gender || "-"}</span></li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Email:</strong> {profile.email || "-"}</li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Phone:</strong> {profile.phone || "-"}</li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Education:</strong> {profile.education || "-"}</li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Job Type:</strong> <span style={{ textTransform: "capitalize" }}>{profile.jobtype || profile.jobType || profile.employedIn || "-"}</span></li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Occupation:</strong> <span style={{ textTransform: "capitalize" }}>{profile.occupation || "-"}</span></li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Salary:</strong> {profile.salary || profile.monthlyIncome || "-"}</li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Kulam:</strong> <span style={{ textTransform: "capitalize" }}>{profile.kulam || "-"}</span></li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Dhosam:</strong> <span style={{ textTransform: "capitalize" }}>{profile.dhosam || "-"}</span></li>
                                          <li><strong style={{ width: "100px", display: "inline-block" }}>Location:</strong> <span style={{ textTransform: "capitalize" }}>{locationString}</span></li>
                                        </ul>

                                        {/* View Button */}
                                        <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
                                          <a
                                            href={`/dashboard1/${profile.interestProfileId}`}
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: 500,
                                              border: "1px solid #dee2e6",
                                              background: "#f6f8fa",
                                              color: "#333",
                                              borderRadius: "5px",
                                              padding: "6px 18px",
                                              textDecoration: "none",
                                            }}
                                          >
                                            View
                                          </a>
                                        </div>
                                      </div>
                                    </Col>
                                  );
                                })}
                              </Row>
                            )}
                          </div>
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Col xs={12} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search2}
                                  onChange={(e) => setSearch2(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search2, setGetUser2)
                                  }
                                  results={getUser2}
                                  onSelect={(user) => {
                                    setSelectedUser2(user);
                                    setSearch2(user.userName || "");
                                    setGetUser2([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser2 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser2.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser2.profileId || ""}
                                      </span>
                                    </h3>
                                  </div>{" "}
                                </Col>
                              )}
                              {selectedUser2 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleInterset}
                                  >
                                    Interest lock Profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {selectedUser2 && showLocked && (
                                <Col>
                                  {/* Dropdown for user selection */}
                                  <Card body className="p-3">
                                    {Array.isArray(interest) &&
                                      interest.length > 0 ? (
                                      <select
                                        className="form-select"
                                        value={setInterestId} // ✅ use state variable
                                        onChange={handleInterestChange}
                                      >
                                        <option value="">
                                          -- Select User --
                                        </option>
                                        {interest.map((u) => (
                                          <option
                                            key={u.id}
                                            value={u.id}
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {u.userName || "Unknown"} (
                                            {u.profileId || ""})
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <p>No Interest lock Profiles</p> // ✅ show message if array empty
                                    )}
                                  </Card>
                                </Col>
                              )}
                              {selectedInterest ? (
                                <Col key={selectedInterest.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedInterest.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedInterest.profileId || ""}
                                      </span>
                                    </h3>

                                    <div
                                      style={{
                                        marginTop: 10,
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        className="btn btn-success btn-sm me-2"
                                        onClick={() =>
                                          handleInterest(
                                            selectedUser2.id,
                                            selectedInterest.id,
                                            "accept"
                                          )
                                        }
                                      >
                                        Accept
                                      </button>
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() =>
                                          handleInterest(
                                            selectedUser2.id,
                                            selectedInterest.id,
                                            "decline"
                                          )
                                        }
                                      >
                                        Reject
                                      </button>
                                    </div>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          </section>
                          {selectedUser2 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser2 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser2 &&
                                        selectedUser2.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser2 &&
                                        selectedUser2.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser2 && selectedUser2.dob) || ""
                                    }
                                    education={
                                      (selectedUser2 &&
                                        selectedUser2.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser2 &&
                                        selectedUser2.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser2 &&
                                        selectedUser2.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser2 &&
                                        selectedUser2.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser2 && selectedUser2.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser2 && selectedUser2.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser2 && selectedUser2.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser2 && selectedUser2.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser2 && selectedUser2.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser2 && selectedUser2.taluk,
                                      selectedUser2 && selectedUser2.district,
                                      selectedUser2 && selectedUser2.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser2 && selectedUser2.profilePic
                                        ? selectedUser2 &&
                                        selectedUser2.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser2 && (
                                  <>
                                    {selectedInterest ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={selectedInterest.userName || ""}
                                          profileId={
                                            selectedInterest.profileId || ""
                                          }
                                          dob={selectedInterest.dob || ""}
                                          education={
                                            selectedInterest.education || ""
                                          }
                                          employedIn={
                                            selectedInterest.employedIn || ""
                                          }
                                          occupation={
                                            selectedInterest.occupation || ""
                                          }
                                          monthlyIncome={
                                            selectedInterest.monthlyIncome || ""
                                          }
                                          kulam={selectedInterest.kulam || ""}
                                          dhosam={selectedInterest.dhosam || ""}
                                          phone={selectedInterest.phone || ""}
                                          gender={selectedInterest.gender || ""}
                                          location={[
                                            selectedInterest.taluk,
                                            selectedInterest.district,
                                            selectedInterest.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          image={
                                            selectedInterest.profilePic
                                              ? selectedInterest.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>{" "}
                <TabPane tabId="3">
                  <Row>
                    <Col xs={12} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search3}
                                  onChange={(e) => setSearch3(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search3, setGetUser3)
                                  }
                                  results={getUser3}
                                  onSelect={(user) => {
                                    setSelectedUser3(user);
                                    setSearch3(user.userName || "");
                                    setGetUser3([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser3 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser3.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser3.profileId || ""}
                                      </span>
                                    </h3>
                                  </div>{" "}
                                </Col>
                              )}
                              {selectedUser3 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleHoroscope}
                                  >
                                    Horoscope lock Profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {selectedUser3 && showLocked && (
                                <Col>
                                  {/* Dropdown for user selection */}
                                  <Card body className="p-3">
                                    {Array.isArray(horoscope) &&
                                      horoscope.length > 0 ? (
                                      <select
                                        className="form-select"
                                        value={horoscopeId} // ✅ use state variable
                                        onChange={handleHoroscopeChange}
                                      >
                                        <option value="">
                                          -- Select User --
                                        </option>
                                        {horoscope.map((u) => (
                                          <option
                                            key={u.id}
                                            value={u.id}
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {u.userName || "Unknown"} (
                                            {u.profileId || ""})
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <p>No Horoscope lock Profiles</p> // ✅ show this if array is empty
                                    )}
                                  </Card>
                                </Col>
                              )}
                              {selectedHoroscope ? (
                                <Col key={selectedHoroscope.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedHoroscope.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedHoroscope.profileId || ""}
                                      </span>
                                    </h3>

                                    <div
                                      style={{
                                        marginTop: 10,
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        className="btn btn-success btn-sm me-3"
                                        onClick={() =>
                                          handleMatch(
                                            selectedUser3.id,
                                            selectedHoroscope.id,
                                            "goodmatch"
                                          )
                                        }
                                      >
                                        Good Match
                                      </button>
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() =>
                                          handleMatch(
                                            selectedUser3.id,
                                            selectedHoroscope.id,
                                            "notmatch"
                                          )
                                        }
                                      >
                                        Not Match
                                      </button>
                                    </div>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          </section>
                          {selectedUser3 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser3 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser3 &&
                                        selectedUser3.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser3 &&
                                        selectedUser3.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser3 && selectedUser3.dob) || ""
                                    }
                                    education={
                                      (selectedUser3 &&
                                        selectedUser3.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser3 &&
                                        selectedUser3.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser3 &&
                                        selectedUser3.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser3 &&
                                        selectedUser3.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser3 && selectedUser3.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser3 && selectedUser3.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser3 && selectedUser3.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser3 && selectedUser3.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser3 && selectedUser3.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser3 && selectedUser3.taluk,
                                      selectedUser3 && selectedUser3.district,
                                      selectedUser3 && selectedUser3.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser3 && selectedUser3.profilePic
                                        ? selectedUser3 &&
                                        selectedUser3.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser3 && (
                                  <>
                                    {selectedHoroscope ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={
                                            selectedHoroscope.userName || ""
                                          }
                                          profileId={
                                            selectedHoroscope.profileId || ""
                                          }
                                          dob={selectedHoroscope.dob || ""}
                                          education={
                                            selectedHoroscope.education || ""
                                          }
                                          employedIn={
                                            selectedHoroscope.employedIn || ""
                                          }
                                          occupation={
                                            selectedHoroscope.occupation || ""
                                          }
                                          monthlyIncome={
                                            selectedHoroscope.monthlyIncome ||
                                            ""
                                          }
                                          kulam={selectedHoroscope.kulam || ""}
                                          dhosam={
                                            selectedHoroscope.dhosam || ""
                                          }
                                          phone={selectedHoroscope.phone || ""}
                                          gender={
                                            selectedHoroscope.gender || ""
                                          }
                                          location={[
                                            selectedHoroscope.taluk,
                                            selectedHoroscope.district,
                                            selectedHoroscope.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          image={
                                            selectedHoroscope.profilePic
                                              ? selectedHoroscope.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>{" "}
                <TabPane tabId="4">
                  <Row>
                    <Col xs={12} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search4}
                                  onChange={(e) => setSearch4(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search4, setGetUser4)
                                  }
                                  results={getUser4}
                                  onSelect={(user) => {
                                    setSelectedUser4(user);
                                    setSearch4(user.userName || "");
                                    setGetUser4([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser4 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser4.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser4.profileId || ""}
                                      </span>
                                    </h3>
                                  </div>{" "}
                                </Col>
                              )}
                              {selectedUser4 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleMeet}
                                  >
                                    Waiting to meet Profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {selectedUser4 && showLocked && (
                                <Col>
                                  {/* Dropdown for user selection */}
                                  <Card body className="p-3">
                                    {Array.isArray(meet) && meet.length > 0 ? (
                                      <select
                                        className="form-select"
                                        value={waitMeetId} // ✅ use state variable
                                        onChange={handleWaitMeetChange}
                                      >
                                        <option value="">
                                          -- Select User --
                                        </option>
                                        {meet.map((u) => (
                                          <option
                                            key={u.id}
                                            value={u.id}
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {u.userName || "Unknown"} (
                                            {u.profileId || ""})
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <p>No Waiting to meet Profiles</p> // ✅ show this if array is empty
                                    )}
                                  </Card>
                                </Col>
                              )}
                              {selectedWaitMeet ? (
                                <Col key={selectedWaitMeet.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedWaitMeet.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedWaitMeet.profileId || ""}
                                      </span>
                                    </h3>

                                    <div style={{ marginTop: 10 }}>
                                      <button
                                        className="btn btn-success btn-sm me-4"
                                        onClick={() =>
                                          handleLock(
                                            selectedUser4.id,
                                            selectedWaitMeet.id
                                          )
                                        }
                                      >
                                        Lock
                                      </button>
                                    </div>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          </section>
                          {selectedUser4 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser4 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser4 &&
                                        selectedUser4.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser4 &&
                                        selectedUser4.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser4 && selectedUser4.dob) || ""
                                    }
                                    education={
                                      (selectedUser4 &&
                                        selectedUser4.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser4 &&
                                        selectedUser4.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser4 &&
                                        selectedUser4.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser4 &&
                                        selectedUser4.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser4 && selectedUser4.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser4 && selectedUser4.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser4 && selectedUser4.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser4 && selectedUser4.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser4 && selectedUser4.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser4 && selectedUser4.taluk,
                                      selectedUser4 && selectedUser4.district,
                                      selectedUser4 && selectedUser4.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser4 && selectedUser4.profilePic
                                        ? selectedUser4 &&
                                        selectedUser4.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser4 && (
                                  <>
                                    {selectedWaitMeet ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={selectedWaitMeet.userName || ""}
                                          profileId={
                                            selectedWaitMeet.profileId || ""
                                          }
                                          dob={selectedWaitMeet.dob || ""}
                                          education={
                                            selectedWaitMeet.education || ""
                                          }
                                          employedIn={
                                            selectedWaitMeet.employedIn || ""
                                          }
                                          occupation={
                                            selectedWaitMeet.occupation || ""
                                          }
                                          monthlyIncome={
                                            selectedWaitMeet.monthlyIncome || ""
                                          }
                                          kulam={selectedWaitMeet.kulam || ""}
                                          dhosam={selectedWaitMeet.dhosam || ""}
                                          phone={selectedWaitMeet.phone || ""}
                                          gender={selectedWaitMeet.gender || ""}
                                          location={[
                                            selectedWaitMeet.taluk,
                                            selectedWaitMeet.district,
                                            selectedWaitMeet.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          image={
                                            selectedWaitMeet.profilePic
                                              ? selectedWaitMeet.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="5">
                  <Row>
                    <Col xs={14} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search5}
                                  onChange={(e) => setSearch5(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search5, setGetUser5)
                                  }
                                  results={getUser5}
                                  onSelect={(user) => {
                                    setSelectedUser5(user);
                                    setSearch5(user.userName || "");
                                    setGetUser5([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser5 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser5.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser5.profileId || ""}
                                      </span>
                                    </h3>

                                    {/* ✅ First Toggle */}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: 10,
                                      }}
                                    >
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={isAccepted1}
                                          onChange={() =>
                                            handleToggle(
                                              "first",
                                              selectedUser5.id,
                                              selectedWaitResult.id
                                            )
                                          }
                                          disabled={
                                            !selectedUser5 ||
                                            !selectedWaitResult
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <span
                                        style={{
                                          marginLeft: 10,
                                          fontWeight: "600",
                                          color: isAccepted1
                                            ? "#3b923f"
                                            : "#e74c3c",
                                        }}
                                      >
                                        {isAccepted1 ? "Accepted" : "Rejected"}
                                      </span>
                                    </div>
                                  </div>
                                  {/* ✅ Inline CSS for the Toggle */}
                                  <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 50px;
          height: 26px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: 0.4s;
          border-radius: 34px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 20px;
          width: 20px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: 0.4s;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: #3b923f;
        }

        input:checked + .slider:before {
          transform: translateX(24px);
        }

        .slider.round {
          border-radius: 34px;
        }
      `}</style>
                                </Col>
                              )}
                              {selectedUser5 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleResult}
                                  >
                                    Waiting for result Profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {selectedUser5 && showLocked && (
                                <Col>
                                  {/* Dropdown for user selection */}
                                  <Card body className="p-3">
                                    {Array.isArray(result) &&
                                      result.length > 0 ? (
                                      <select
                                        className="form-select"
                                        value={waitResultId} // ✅ use state value, not setter
                                        onChange={handleWaitResultChange}
                                      >
                                        <option value="">
                                          -- Select User --
                                        </option>
                                        {result.map((u) => (
                                          <option
                                            key={u.id}
                                            value={u.id}
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {u.userName || "Unknown"} (
                                            {u.profileId || ""})
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <p>No Waiting for result Profiles</p> // ✅ show this if array is empty
                                    )}
                                  </Card>
                                </Col>
                              )}
                              {selectedWaitResult ? (
                                <Col key={selectedWaitResult.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedWaitResult.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedWaitResult.profileId || ""}
                                      </span>
                                    </h3>

                                    {/* ✅ Second Toggle */}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: 10,
                                      }}
                                    >
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={isAccepted2}
                                          onChange={() =>
                                            handleToggle(
                                              "second",

                                              selectedUser5.id,
                                              selectedWaitResult.id
                                            )
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <span
                                        style={{
                                          marginLeft: 10,
                                          fontWeight: "600",
                                          color: isAccepted2
                                            ? "#3b923f"
                                            : "#e74c3c",
                                        }}
                                      >
                                        {isAccepted2 ? "Accepted" : "Rejected"}
                                      </span>
                                    </div>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          </section>
                          {selectedUser5 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser5 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser5 &&
                                        selectedUser5.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser5 &&
                                        selectedUser5.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser5 && selectedUser5.dob) || ""
                                    }
                                    education={
                                      (selectedUser5 &&
                                        selectedUser5.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser5 &&
                                        selectedUser5.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser5 &&
                                        selectedUser5.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser5 &&
                                        selectedUser5.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser5 && selectedUser5.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser5 && selectedUser5.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser5 && selectedUser5.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser5 && selectedUser5.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser5 && selectedUser5.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser5 && selectedUser5.taluk,
                                      selectedUser5 && selectedUser5.district,
                                      selectedUser5 && selectedUser5.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser5 && selectedUser5.profilePic
                                        ? selectedUser5 &&
                                        selectedUser5.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser5 && (
                                  <>
                                    {selectedWaitResult ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={
                                            selectedWaitResult.userName || ""
                                          }
                                          profileId={
                                            selectedWaitResult.profileId || ""
                                          }
                                          dob={selectedWaitResult.dob || ""}
                                          education={
                                            selectedWaitResult.education || ""
                                          }
                                          employedIn={
                                            selectedWaitResult.employedIn || ""
                                          }
                                          occupation={
                                            selectedWaitResult.occupation || ""
                                          }
                                          monthlyIncome={
                                            selectedWaitResult.monthlyIncome ||
                                            ""
                                          }
                                          kulam={selectedWaitResult.kulam || ""}
                                          dhosam={
                                            selectedWaitResult.dhosam || ""
                                          }
                                          phone={selectedWaitResult.phone || ""}
                                          gender={
                                            selectedWaitResult.gender || ""
                                          }
                                          location={[
                                            selectedWaitResult.taluk,
                                            selectedWaitResult.district,
                                            selectedWaitResult.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          image={
                                            selectedWaitResult.profilePic
                                              ? selectedWaitResult.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>{" "}
                <TabPane tabId="6">
                  <Row>
                    <Col xs={15} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search6}
                                  onChange={(e) => setSearch6(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search6, setGetUser6)
                                  }
                                  results={getUser6}
                                  onSelect={(user) => {
                                    setSelectedUser6(user);
                                    setSearch6(user.userName || "");
                                    setGetUser6([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser6 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser6.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser6.profileId || ""}
                                      </span>
                                    </h3>
                                  </div>{" "}
                                </Col>
                              )}
                              {selectedUser6 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleMarriage}
                                  >
                                    Marriage Processing Profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {selectedUser6 && showLocked && (
                                <Col>
                                  {/* Dropdown for user selection */}
                                  <Card body className="p-3">
                                    {Array.isArray(marriage) &&
                                      marriage.length > 0 ? (
                                      <select
                                        className="form-select"
                                        value={marriageId} // ✅ use state value
                                        onChange={handleMarriageChange}
                                      >
                                        <option value="">
                                          -- Select User --
                                        </option>
                                        {marriage.map((u) => (
                                          <option
                                            key={u.id}
                                            value={u.id}
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {u.userName || "Unknown"} (
                                            {u.profileId || ""})
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <p>No Marriage Processing Profiles</p> // ✅ show message if array is empty
                                    )}
                                  </Card>
                                </Col>
                              )}
                              {selectedMarriage ? (
                                <Col key={selectedMarriage.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedMarriage.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedMarriage.profileId || ""}
                                      </span>
                                    </h3>
                                    <div
                                      style={{
                                        marginTop: 10,
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        className="btn btn-success btn-sm me-6"
                                        onClick={() =>
                                          handleMarraigeProcessing(
                                            selectedUser6.id,
                                            selectedMarriage.id,
                                            "accept"
                                          )
                                        }
                                      >
                                        Confirm
                                      </button>
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() =>
                                          handleMarraigeProcessing(
                                            selectedUser6.id,
                                            selectedMarriage.id,
                                            "reject"
                                          )
                                        }
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          </section>
                          {selectedUser6 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser6 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser6 &&
                                        selectedUser6.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser6 &&
                                        selectedUser6.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser6 && selectedUser6.dob) || ""
                                    }
                                    education={
                                      (selectedUser6 &&
                                        selectedUser6.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser6 &&
                                        selectedUser6.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser6 &&
                                        selectedUser6.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser6 &&
                                        selectedUser6.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser6 && selectedUser6.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser6 && selectedUser6.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser6 && selectedUser6.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser6 && selectedUser6.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser6 && selectedUser6.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser6 && selectedUser6.taluk,
                                      selectedUser6 && selectedUser6.district,
                                      selectedUser6 && selectedUser6.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser6 && selectedUser6.profilePic
                                        ? selectedUser6 &&
                                        selectedUser6.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser6 && (
                                  <>
                                    {selectedMarriage ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={selectedMarriage.userName || ""}
                                          profileId={
                                            selectedMarriage.profileId || ""
                                          }
                                          dob={selectedMarriage.dob || ""}
                                          education={
                                            selectedMarriage.education || ""
                                          }
                                          employedIn={
                                            selectedMarriage.employedIn || ""
                                          }
                                          occupation={
                                            selectedMarriage.occupation || ""
                                          }
                                          monthlyIncome={
                                            selectedMarriage.monthlyIncome || ""
                                          }
                                          kulam={selectedMarriage.kulam || ""}
                                          dhosam={selectedMarriage.dhosam || ""}
                                          phone={selectedMarriage.phone || ""}
                                          gender={selectedMarriage.gender || ""}
                                          location={[
                                            selectedMarriage.taluk,
                                            selectedMarriage.district,
                                            selectedMarriage.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          image={
                                            selectedMarriage.profilePic
                                              ? selectedMarriage.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>{" "}
                <TabPane tabId="7">
                  <Row>
                    <Col xs={12} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search7}
                                  onChange={(e) => setSearch7(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search7, setGetUser7)
                                  }
                                  results={getUser7}
                                  onSelect={(user) => {
                                    setSelectedUser7(user);
                                    setSearch7(user.userName || "");
                                    setGetUser7([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser7 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser7.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser7.profileId || ""}
                                      </span>
                                    </h3>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: 10,
                                      }}
                                    >
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={isAccepted3}
                                          onChange={() =>
                                            handleToggleReject(
                                              "first",
                                              selectedUser7.id,
                                              selectedReject.id
                                            )
                                          }
                                          disabled={
                                            !selectedUser7 || !selectedReject
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <span
                                        style={{
                                          marginLeft: 10,
                                          fontWeight: "600",
                                          color: isAccepted3
                                            ? "#3b923f"
                                            : "#e74c3c",
                                        }}
                                      >
                                        {isAccepted3 ? "Accepted" : "Rejected"}
                                      </span>
                                    </div>
                                  </div>{" "}
                                  <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 50px;
          height: 26px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: 0.4s;
          border-radius: 34px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 20px;
          width: 20px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: 0.4s;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: #3b923f;
        }

        input:checked + .slider:before {
          transform: translateX(24px);
        }

        .slider.round {
          border-radius: 34px;
        }
      `}</style>
                                </Col>
                              )}
                              {selectedUser7 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleReject}
                                  >
                                    Marriage Rejected Profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {reject && showLocked && (
                                <Col>
                                  {/* Dropdown for user selection */}
                                  <Card body className="p-3">
                                    {Array.isArray(reject) &&
                                      reject.length > 0 ? (
                                      <select
                                        className="form-select"
                                        value={rejectId} // your state
                                        onChange={handleRejectChange}
                                      >
                                        <option value="">
                                          -- Select User --
                                        </option>
                                        {reject.map((u) => (
                                          <option key={u.id} value={u.id}>
                                            {u.userName || "Unknown"} (
                                            {u.profileId || ""})
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <p>No Marriage Rejected Profiles</p>
                                    )}
                                  </Card>
                                </Col>
                              )}
                              {selectedReject ? (
                                <Col key={selectedReject.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedReject.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedReject.profileId || ""}
                                      </span>
                                    </h3>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: 10,
                                      }}
                                    >
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={isAccepted4}
                                          onChange={() =>
                                            handleToggleReject(
                                              "second",

                                              selectedUser7.id,
                                              selectedReject.id
                                            )
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <span
                                        style={{
                                          marginLeft: 10,
                                          fontWeight: "600",
                                          color: isAccepted4
                                            ? "#3b923f"
                                            : "#e74c3c",
                                        }}
                                      >
                                        {isAccepted4 ? "Accepted" : "Rejected"}
                                      </span>
                                    </div>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          </section>
                          {selectedUser7 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser7 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser7 &&
                                        selectedUser7.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser7 &&
                                        selectedUser7.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser7 && selectedUser7.dob) || ""
                                    }
                                    education={
                                      (selectedUser7 &&
                                        selectedUser7.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser7 &&
                                        selectedUser7.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser7 &&
                                        selectedUser7.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser7 &&
                                        selectedUser7.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser7 && selectedUser7.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser7 && selectedUser7.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser7 && selectedUser7.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser7 && selectedUser7.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser7 && selectedUser7.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser7 && selectedUser7.taluk,
                                      selectedUser7 && selectedUser7.district,
                                      selectedUser7 && selectedUser7.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser7 && selectedUser7.profilePic
                                        ? selectedUser7 &&
                                        selectedUser7.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser7 && (
                                  <>
                                    {selectedReject ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={selectedReject.userName || ""}
                                          profileId={
                                            selectedReject.profileId || ""
                                          }
                                          dob={selectedReject.dob || ""}
                                          education={
                                            selectedReject.education || ""
                                          }
                                          employedIn={
                                            selectedReject.employedIn || ""
                                          }
                                          occupation={
                                            selectedReject.occupation || ""
                                          }
                                          monthlyIncome={
                                            selectedReject.monthlyIncome || ""
                                          }
                                          kulam={selectedReject.kulam || ""}
                                          dhosam={selectedReject.dhosam || ""}
                                          phone={selectedReject.phone || ""}
                                          gender={selectedReject.gender || ""}
                                          location={[
                                            selectedReject.taluk,
                                            selectedReject.district,
                                            selectedReject.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          image={
                                            selectedReject.profilePic
                                              ? selectedReject.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="8">
                  <Row>
                    <Col xs={12} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search8}
                                  onChange={(e) => setSearch8(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search8, setGetUser8)
                                  }
                                  results={getUser8}
                                  onSelect={(user) => {
                                    setSelectedUser8(user);
                                    setSearch8(user.userName || "");
                                    setGetUser8([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser8 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser8.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser8.profileId || ""}
                                      </span>
                                    </h3>
                                  </div>{" "}
                                </Col>
                              )}
                              {selectedUser8 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleReject}
                                  >
                                    Admin Locked profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {locked && showLocked && (
                                <>
                                  {Array.isArray(locked) &&
                                    locked.length > 0 ? (
                                    locked.map((u, index) => (
                                      <Col key={index}>
                                        <div
                                          style={{
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 10,
                                            padding: 12,
                                            boxShadow:
                                              "0 2px 6px rgba(0,0,0,0.06)",
                                            background: "#fff",
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <h3
                                            style={{
                                              margin: "0 0 8px 0",
                                              fontSize: 18,
                                              textTransform: "capitalize",
                                              fontWeight: "800",
                                            }}
                                          >
                                            {u.userName || "Unknown"}{" "}
                                            <span
                                              style={{
                                                fontWeight: "800",
                                                color: "#3b923f",
                                              }}
                                            >
                                              {u.profileId || ""}
                                            </span>
                                          </h3>

                                          <div style={{ marginTop: 10 }}>
                                            <button className="btn btn-success btn-sm me-2">
                                              Accept
                                            </button>
                                            <button className="btn btn-danger btn-sm">
                                              Reject
                                            </button>
                                          </div>
                                        </div>
                                      </Col>
                                    ))
                                  ) : (
                                    <Col>
                                      <p>No get Married Profiles</p>
                                    </Col>
                                  )}
                                </>
                              )}
                            </Row>
                          </section>
                          {selectedUser8 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser8 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser8 &&
                                        selectedUser8.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser8 &&
                                        selectedUser8.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser8 && selectedUser8.dob) || ""
                                    }
                                    education={
                                      (selectedUser8 &&
                                        selectedUser8.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser8 &&
                                        selectedUser8.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser8 &&
                                        selectedUser8.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser8 &&
                                        selectedUser8.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser8 && selectedUser8.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser8 && selectedUser8.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser8 && selectedUser8.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser8 && selectedUser8.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser8 && selectedUser8.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser8 && selectedUser8.taluk,
                                      selectedUser8 && selectedUser8.district,
                                      selectedUser8 && selectedUser8.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser8 && selectedUser8.profilePic
                                        ? selectedUser8 &&
                                        selectedUser8.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser8 && (
                                  <>
                                    {Array.isArray(locked) &&
                                      locked.length > 0 ? (
                                      locked.map((u, index) => (
                                        <Col md={4} key={index}>
                                          <Usercard
                                            name={(u && u.userName) || ""}
                                            profileId={(u && u.profileId) || ""}
                                            dob={(u && u.dob) || ""}
                                            education={(u && u.education) || ""}
                                            employedIn={
                                              (u && u.employedIn) || ""
                                            }
                                            occupation={
                                              (u && u.occupation) || ""
                                            }
                                            monthlyIncome={
                                              (u && u.monthlyIncome) || ""
                                            }
                                            kulam={(u && u.kulam) || ""}
                                            dhosam={(u && u.dhosam) || ""}
                                            phone={(u && u.phone) || ""}
                                            location={[
                                              u && u.taluk,
                                              u && u.district,
                                              u && u.state,
                                            ]
                                              .filter(Boolean)
                                              .join(", ")}
                                            image={
                                              u && u.profilePic
                                                ? u && u.profilePic
                                                : icon
                                            }
                                          />
                                        </Col>
                                      ))
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="9">
                  <Row>
                    <Col xs={12} md={12}>
                      <Row>
                        <div className="container-fluid">
                          <section
                            style={{
                              display: "flex",
                            }}
                          >
                            <Row className="mt-3">
                              <Col>
                                <SearchField
                                  value={search9}
                                  onChange={(e) => setSearch9(e.target.value)}
                                  onSearch={() =>
                                    searchMember(search9, setGetUser9)
                                  }
                                  results={getUser9}
                                  onSelect={(user) => {
                                    setSelectedUser9(user);
                                    setSearch9(user.userName || "");
                                    setGetUser9([]);
                                  }}
                                />{" "}
                              </Col>
                              {selectedUser9 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedUser9.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedUser9.profileId || ""}
                                      </span>
                                    </h3>
                                  </div>{" "}
                                </Col>
                              )}
                              {selectedUser9 && (
                                <Col>
                                  {" "}
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column", cursor: "pointer"
                                    }}
                                    onClick={handleGetMarried}
                                  >
                                    Get Married Profiles
                                  </div>{" "}
                                </Col>
                              )}{" "}
                              {getmarried && showLocked && (
                                <Col>
                                  {/* Dropdown for user selection */}
                                  <Card body className="p-3">
                                    {Array.isArray(getmarried) &&
                                      getmarried.length > 0 ? (
                                      <select
                                        className="form-select"
                                        value={getMarriedId} // ✅ use state value
                                        onChange={handleGetMarriedChange}
                                      >
                                        <option value="">
                                          -- Select User --
                                        </option>
                                        {getmarried.map((u) => (
                                          <option
                                            key={u.id}
                                            value={u.id}
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {u.userName || "Unknown"} (
                                            {u.profileId || ""})
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <p>NoGet Married Profiles</p> // ✅ show p tag if array empty
                                    )}
                                  </Card>
                                </Col>
                              )}
                              {selectedGetMarried ? (
                                <Col key={selectedGetMarried.id}>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: 10,
                                      padding: 12,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                      background: "#fff",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {/* ✅ Profile Heading */}
                                    <h3
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: 18,
                                        textTransform: "capitalize",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {selectedGetMarried.userName || "Unknown"}{" "}
                                      <span
                                        style={{
                                          fontWeight: "800",
                                          color: "#3b923f",
                                        }}
                                      >
                                        {selectedGetMarried.profileId || ""}
                                      </span>
                                    </h3>
                                    <div
                                      style={{
                                        marginTop: 10,
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        className="btn btn-success btn-sm me-9"
                                        onClick={() =>
                                          handleMarraige(
                                            selectedUser9.id,
                                            selectedGetMarried.id,
                                            "confirm"
                                          )
                                        }
                                      >
                                        Congratulation
                                      </button>
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() =>
                                          handleMarraige(
                                            selectedUser9.id,
                                            selectedGetMarried.id,
                                            "remove"
                                          )
                                        }
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          </section>
                          {selectedUser9 && (
                            <>
                              {" "}
                              <Row className="mt-3">
                                {/* First card: selectedUser9 */}
                                <Col md={4}>
                                  <Usercard
                                    name={
                                      (selectedUser9 &&
                                        selectedUser9.userName) ||
                                      ""
                                    }
                                    profileId={
                                      (selectedUser9 &&
                                        selectedUser9.profileId) ||
                                      ""
                                    }
                                    dob={
                                      (selectedUser9 && selectedUser9.dob) || ""
                                    }
                                    education={
                                      (selectedUser9 &&
                                        selectedUser9.education) ||
                                      ""
                                    }
                                    employedIn={
                                      (selectedUser9 &&
                                        selectedUser9.employedIn) ||
                                      ""
                                    }
                                    occupation={
                                      (selectedUser9 &&
                                        selectedUser9.occupation) ||
                                      ""
                                    }
                                    monthlyIncome={
                                      (selectedUser9 &&
                                        selectedUser9.monthlyIncome) ||
                                      ""
                                    }
                                    kulam={
                                      (selectedUser9 && selectedUser9.kulam) ||
                                      ""
                                    }
                                    dhosam={
                                      (selectedUser9 && selectedUser9.dhosam) ||
                                      ""
                                    }
                                    phone={
                                      (selectedUser9 && selectedUser9.phone) ||
                                      ""
                                    }
                                    gender={
                                      (selectedUser9 && selectedUser9.gender) ||
                                      ""
                                    }
                                    email={
                                      (selectedUser9 && selectedUser9.email) ||
                                      ""
                                    }
                                    location={[
                                      selectedUser9 && selectedUser9.taluk,
                                      selectedUser9 && selectedUser9.district,
                                      selectedUser9 && selectedUser9.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    image={
                                      selectedUser9 && selectedUser9.profilePic
                                        ? selectedUser9 &&
                                        selectedUser9.profilePic
                                        : icon
                                    }
                                  />
                                </Col>

                                {selectedUser9 && (
                                  <>
                                    {selectedGetMarried ? (
                                      <Col md={5}>
                                        <Usercard
                                          name={
                                            selectedGetMarried.userName || ""
                                          }
                                          profileId={
                                            selectedGetMarried.profileId || ""
                                          }
                                          dob={selectedGetMarried.dob || ""}
                                          education={
                                            selectedGetMarried.education || ""
                                          }
                                          employedIn={
                                            selectedGetMarried.employedIn || ""
                                          }
                                          occupation={
                                            selectedGetMarried.occupation || ""
                                          }
                                          monthlyIncome={
                                            selectedGetMarried.monthlyIncome ||
                                            ""
                                          }
                                          kulam={selectedGetMarried.kulam || ""}
                                          dhosam={
                                            selectedGetMarried.dhosam || ""
                                          }
                                          phone={selectedGetMarried.phone || ""}
                                          gender={
                                            selectedGetMarried.gender || ""
                                          }
                                          location={[
                                            selectedGetMarried.taluk,
                                            selectedGetMarried.district,
                                            selectedGetMarried.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                          image={
                                            selectedGetMarried.profilePic
                                              ? selectedGetMarried.profilePic
                                              : icon
                                          }
                                        />
                                      </Col>
                                    ) : (
                                      <p>No data found</p>
                                    )}
                                  </>
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </section>
        </Col>
      </Row>
    </div>
  );
};

export default ChatBoxApprovel;
